import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';
import { timer } from 'rxjs';

import { appClose16Icon } from '@icons/close-16';
import { appFaulted16Icon } from '@icons/faulted-16';
import { appInfo16Icon } from '@icons/info-16';
import { appReady24Icon } from '@icons/ready-24';
import { appWarning16Icon } from '@icons/warning-16';

import { TOAST_MESSAGE_REF } from './toast-message-tokens';
import { ToastMessageType } from './toast-message.view-model';

@Component({
  selector: 'app-toast-message',
  imports: [NgClass, SvgIconComponent, AsyncPipe],
  templateUrl: './toast-message.component.html',
  styleUrl: './toast-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastMessageComponent {
  readonly #destroyRef = inject(DestroyRef);
  public readonly toastMessageRef = inject(TOAST_MESSAGE_REF);

  public readonly ToastMessageType = ToastMessageType;

  constructor() {
    injectRegisterIcons([appReady24Icon, appInfo16Icon, appWarning16Icon, appFaulted16Icon, appClose16Icon]);

    if (this.toastMessageRef.vm.duration) {
      timer(this.toastMessageRef.vm.duration)
        .pipe(takeUntilDestroyed(this.#destroyRef))
        .subscribe(() => {
          this.toastMessageRef.close();
        });
    }
  }

  public onCloseClick(): void {
    this.toastMessageRef.close();
  }
}
